<div class="main-content">
	<div class="container-fluid">
		<div class="row tp-wrapper m-0 p-0">
			<div class="col-md-12 ">
				<div class="card ">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title">
							<i class="material-icons">arrow_left</i> Statements
						</h4>
					</div>

					<div class="card-body">
						<!--left-->
						<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
							<mat-tab label="Statement Messages" class="no-overflow">
								<ng-template matTabContent>
									<div class="sm-tab" *ngIf="statement_text?.length">

										<!-- Banner -->
										<div class="sm-banner">
											<mat-icon class="sm-banner__icon" aria-hidden="true">campaign</mat-icon>
											<div class="sm-banner__text">
												<strong>Statement letter copy</strong>
												<span>These messages print on customer statements. The system picks one block based on how the account is ageing.</span>
											</div>
										</div>

										<!-- Master / Detail -->
										<div class="sm-layout">

											<!-- Master list -->
											<div class="sm-master">
												<div class="sm-master__header">Select message to edit</div>
												<button
													*ngFor="let r of statement_text"
													type="button"
													class="sm-master__row"
													[class.sm-master__row--active]="r.confname === selectedStatementConfname"
													(click)="selectStatementMessage(r.confname)">
													<mat-icon class="sm-master__row-icon">{{ statementMessageIcon(r.confname) }}</mat-icon>
													<div class="sm-master__row-body">
														<div class="sm-master__row-title">{{ displayName(r.confname) }}</div>
														<div class="sm-master__row-preview">{{ messagePreview(r.confname) }}</div>
													</div>
													<mat-icon class="sm-master__row-chevron" aria-hidden="true">chevron_right</mat-icon>
												</button>
											</div>

											<!-- Detail -->
											<div class="sm-detail" *ngIf="selectedStatementConfname && descControls[selectedStatementConfname]">
												<div class="sm-detail__header">
													<mat-icon class="sm-detail__header-icon">{{ statementMessageIcon(selectedStatementConfname) }}</mat-icon>
													<div class="sm-detail__header-text">
														<div class="sm-detail__header-title">{{ displayName(selectedStatementConfname) }}</div>
														<div class="sm-detail__header-sub">{{ messageDescription(selectedStatementConfname) }}</div>
													</div>
												</div>
												<div class="sm-detail__editor">
													<app-wysiwyg-editor
														layout="full"
														[input]="descControls[selectedStatementConfname]"
														[changed]="selectedStatementConfname"
														[config]="'limited'"
														(data)="updateForm(descControls[selectedStatementConfname], $event)">
													</app-wysiwyg-editor>
												</div>
												<div class="sm-detail__footer">
													<span class="sm-detail__hint">
														<mat-icon aria-hidden="true">info</mat-icon>
														Saves all four messages. Applies on next statement run.
													</span>
													<button
														mat-raised-button
														color="accent"
														type="button"
														[disabled]="savingMessages"
														(click)="saveMessages()">
														<mat-spinner *ngIf="savingMessages" diameter="18" class="sm-save-spinner"></mat-spinner>
														{{ savingMessages ? 'Saving…' : 'Save all messages' }}
													</button>
												</div>
											</div>
										</div>

									</div>
								</ng-template>
							</mat-tab>

							<mat-tab label="Print Statements" class="no-overflow">
								<ng-template matTabContent>
									<form [formGroup]="statementForm" class="no-overflow" *ngIf="statementForm">
										<!-- Customer Range Section -->
										<mat-card class="form-card">
											<mat-card-title>Customer Range</mat-card-title>
											<mat-card-content>
												<mat-divider></mat-divider>
												<div class="row mt-3">
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Starting Customer (Customer code)</mat-label>
															<input type="text" placeholder="Reference" formControlName="FromCust" aria-label="Reference" matInput />
														</mat-form-field>
													</div>
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Ending Customer (Customer code)</mat-label>
															<input type="text" placeholder="Reference" formControlName="ToCust" aria-label="Reference" matInput />
														</mat-form-field>
													</div>
												</div>
											</mat-card-content>
										</mat-card>

										<!-- Date Selection Section -->
										<mat-card class="form-card mt-3">
											<mat-card-title>Date Selection</mat-card-title>
											<mat-card-content>
												<mat-divider></mat-divider>
												<div class="row mt-3">
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Cut off Date</mat-label>
															<input matInput formControlName="dateto" [matDatepicker]="paydatepicker">
															<mat-datepicker-toggle matSuffix [for]="paydatepicker"></mat-datepicker-toggle>
															<mat-datepicker #paydatepicker></mat-datepicker>
														</mat-form-field>
													</div>
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Statement Due Date</mat-label>
															<input matInput formControlName="datedue" [matDatepicker]="paydatepickerdatedue">
															<mat-datepicker-toggle matSuffix [for]="paydatepickerdatedue"></mat-datepicker-toggle>
															<mat-datepicker #paydatepickerdatedue></mat-datepicker>
														</mat-form-field>
													</div>
												</div>
											</mat-card-content>
										</mat-card>

										<!-- Additional Selections Section -->
										<mat-card class="form-card mt-3">
											<mat-card-title>Additional Selections</mat-card-title>
											<mat-card-content>
												<mat-divider></mat-divider>
												<div class="row mt-3">
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Terms</mat-label>
															<mat-select formControlName="paymentterms" multiple appSelectAll>
																<mat-option *ngFor="let term of terms" [value]="term.termsindicator">
																	{{ term.terms }}
																</mat-option>
															</mat-select>
														</mat-form-field>
													</div>
													<div class="col-md-3">
														<mat-form-field appearance="outline" class="full-width">
															<mat-label>Statement Types</mat-label>
															<mat-select formControlName="type" multiple>
																<mat-option value="credit">Credit Balance</mat-option>
																<mat-option value="debit">Debit Balance</mat-option>
															</mat-select>
														</mat-form-field>
													</div>
													<div class="col-md-6 mt-3">
														Customers with Print Statement Flag Only
														<mat-slide-toggle formControlName="printonly"></mat-slide-toggle>
													</div>
												</div>
											</mat-card-content>
										</mat-card>

										<!-- Loading Spinner -->
										<div class="table-responsive text-center mt-3" *ngIf="loading">
											Loading Please Wait...
											<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
												<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
											</svg>
										</div>

										<!-- Print Statements Button -->
										<div class="col-md-12 text-center mt-3" *ngIf="!loading">
											<button mat-raised-button color="primary" (click)="printStatements()">Print Statements</button>
										</div>
									</form>

								</ng-template>
							</mat-tab>
							<mat-tab label="Email Statements" class="no-overflow" *ngIf="statementEmailForm">
								<ng-template matTabContent>
									<mat-tab-group class="email-statements-subtabs" mat-stretch-tabs="false" color="accent"
										(selectedIndexChange)="onEmailSubTabChange($event)">
										<mat-tab label="Schedule job">
											<ng-template matTabContent>
												<form [formGroup]="statementEmailForm" (ngSubmit)="scheduleEmail()" class="email-schedule-form">
													<input type="hidden" formControlName="schedule">
													<input type="hidden" formControlName="script">

													<mat-card class="form-card email-tab-card">
														<mat-card-title>Statement run</mat-card-title>
														<mat-card-subtitle>Transaction cut-off and payment due on the statement PDF</mat-card-subtitle>
														<mat-card-content>
															<mat-divider></mat-divider>
															<div class="row mt-3">
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Statement cut-off</mat-label>
																		<input matInput formControlName="dateto" [matDatepicker]="emailCutoffPicker">
																		<mat-datepicker-toggle matSuffix [for]="emailCutoffPicker"></mat-datepicker-toggle>
																		<mat-datepicker #emailCutoffPicker></mat-datepicker>
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Statement due date</mat-label>
																		<input matInput formControlName="datedue" [matDatepicker]="emailDuePicker">
																		<mat-datepicker-toggle matSuffix [for]="emailDuePicker"></mat-datepicker-toggle>
																		<mat-datepicker #emailDuePicker></mat-datepicker>
																	</mat-form-field>
																</div>
															</div>
														</mat-card-content>
													</mat-card>

													<mat-card class="form-card email-tab-card">
														<mat-card-title>Send when</mat-card-title>
														<mat-card-subtitle>Calendar date and time the email job should start (server time)</mat-card-subtitle>
														<mat-card-content>
															<mat-divider></mat-divider>
															<div class="row mt-3">
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Run on date</mat-label>
																		<input matInput formControlName="job_schedule_date" [matDatepicker]="emailRunDatePicker">
																		<mat-datepicker-toggle matSuffix [for]="emailRunDatePicker"></mat-datepicker-toggle>
																		<mat-datepicker #emailRunDatePicker></mat-datepicker>
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Hour</mat-label>
																		<mat-select formControlName="job_schedule_time">
																			<mat-option *ngFor="let hour of hours" [value]="hour.value">{{ hour.label }}</mat-option>
																		</mat-select>
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Minute</mat-label>
																		<mat-select formControlName="job_schedule_time_min">
																			<mat-option *ngFor="let min of minutes" [value]="min.value">{{ min.label }}</mat-option>
																		</mat-select>
																	</mat-form-field>
																</div>
															</div>
														</mat-card-content>
													</mat-card>

													<mat-card class="form-card email-tab-card">
														<mat-card-title>Customers &amp; terms</mat-card-title>
														<mat-card-content>
															<mat-divider></mat-divider>
															<div class="row mt-3">
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Starting customer</mat-label>
																		<input matInput type="text" maxlength="10" formControlName="FromCust">
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Ending customer</mat-label>
																		<input matInput type="text" maxlength="10" formControlName="ToCust">
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Terms</mat-label>
																		<mat-select formControlName="paymentterms" multiple appSelectAll>
																			<mat-option *ngFor="let term of terms" [value]="term.termsindicator">
																				{{ term.terms }}
																			</mat-option>
																		</mat-select>
																	</mat-form-field>
																</div>
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Statement Types</mat-label>
																		<mat-select formControlName="type" multiple>
																			<mat-option value="credit">Credit Balance</mat-option>
																			<mat-option value="debit">Debit Balance (Owing)</mat-option>
																		</mat-select>
																	</mat-form-field>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-md-4">
																	<mat-form-field appearance="outline" class="full-width">
																		<mat-label>Salesperson (optional)</mat-label>
																		<mat-select formControlName="salesmancode">
																			<mat-option value="">All salespeople</mat-option>
																			<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
																				{{ sp.salesmancode }} — {{ sp.salesmanname }}
																			</mat-option>
																		</mat-select>
																	</mat-form-field>
																</div>
															</div>
														</mat-card-content>
														<mat-card-actions class="card-actions-right">
															<button mat-raised-button color="accent" type="button" (click)="runDryRun()" [disabled]="dryRunLoading">
																<mat-spinner *ngIf="dryRunLoading" diameter="18" style="display:inline-block;margin-right:6px;vertical-align:middle;"></mat-spinner>
																{{ dryRunLoading ? 'Loading…' : 'Dry Run' }}
															</button>
															<button mat-raised-button color="primary" type="submit" style="margin-left:8px;">Schedule email job</button>
														</mat-card-actions>
													</mat-card>

													<!-- Dry Run Results -->
													<mat-card class="form-card email-tab-card" *ngIf="dryRunResults">
														<mat-card-title>
															Dry Run — {{ dryRunResults.count }} customer{{ dryRunResults.count !== 1 ? 's' : '' }} would receive a statement
														</mat-card-title>
														<mat-card-subtitle>
															Total outstanding balance: <strong>{{ dryRunResults.total_balance | number:'1.2-2' }}</strong>
														</mat-card-subtitle>
														<mat-card-content>
															<p *ngIf="!dryRunResults.count" class="text-muted mb-0">No customers match the current filters — no statements would be sent.</p>
															<div class="table-responsive" *ngIf="dryRunResults.count">
																<table class="table table-striped table-sm">
																	<thead class="thead-dark">
																		<tr>
																			<th>Code</th>
																			<th>Customer Name</th>
																			<th>Email</th>
																			<th class="text-right">Balance</th>
																		</tr>
																	</thead>
																	<tbody>
																		<tr *ngFor="let c of dryRunResults.customers">
																			<td>{{ c.debtor }}</td>
																			<td>{{ c.customer_name }}</td>
																			<td>{{ c.email }}</td>
																			<td class="text-right">{{ c.balance | number:'1.2-2' }}</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</mat-card-content>
													</mat-card>
												</form>
											</ng-template>
										</mat-tab>

										<mat-tab label="Active queue">
											<ng-template matTabContent>
												<mat-card class="form-card email-tab-card">
													<mat-card-title>Active &amp; running jobs</mat-card-title>
													<mat-card-content>
														<p *ngIf="!activeEmailJobs.length" class="text-muted mb-0">No scheduled or running jobs.</p>
														<div class="table-responsive" *ngIf="activeEmailJobs.length">
															<table class="table table-striped table-sm">
																<thead class="thead-dark">
																	<tr>
																		<th scope="col">Run at</th>
																		<th scope="col">Cut-off</th>
																		<th scope="col">Statement due</th>
																		<th scope="col">Customers</th>
																		<th scope="col">Records</th>
																		<th scope="col">Last / email</th>
																		<th scope="col" class="text-center">Status</th>
																		<th scope="col" class="text-center">Remove</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let job of activeEmailJobs">
																		<td>{{ job.scheduled }}</td>
																		<td>{{ job.cut_off_date }}</td>
																		<td>{{ job.statement_due }}</td>
																		<td>{{ job.customer_range }}</td>
																		<td>{{ job.records_processed }}</td>
																		<td>{{ job.last_record_email }}</td>
																		<td class="text-center">{{ job.status }}</td>
																		<td class="text-center">
																			<button mat-icon-button color="warn" type="button" aria-label="Remove job" (click)="removeJob(job.job_id)">
																				<mat-icon>delete</mat-icon>
																			</button>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</mat-card-content>
												</mat-card>
											</ng-template>
										</mat-tab>

										<mat-tab label="History">
											<ng-template matTabContent>
												<mat-card class="form-card email-tab-card">
													<mat-card-title>Past jobs</mat-card-title>
													<mat-card-content>
														<p *ngIf="!historyEmailJobs.length" class="text-muted mb-0">No completed or failed jobs in the list.</p>
														<div class="table-responsive" *ngIf="historyEmailJobs.length">
															<table class="table table-striped table-sm">
																<thead class="thead-dark">
																	<tr>
																		<th scope="col">Run at</th>
																		<th scope="col">Cut-off</th>
																		<th scope="col">Statement due</th>
																		<th scope="col">Customers</th>
																		<th scope="col">Records</th>
																		<th scope="col">Last / email</th>
																		<th scope="col" class="text-center">Status</th>
																		<th scope="col" class="text-center">Remove</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let job of historyEmailJobs">
																		<td>{{ job.scheduled }}</td>
																		<td>{{ job.cut_off_date }}</td>
																		<td>{{ job.statement_due }}</td>
																		<td>{{ job.customer_range }}</td>
																		<td>{{ job.records_processed }}</td>
																		<td>{{ job.last_record_email }}</td>
																		<td class="text-center">{{ job.status }}</td>
																		<td class="text-center">
																			<button mat-icon-button color="warn" type="button" aria-label="Remove job" (click)="removeJob(job.job_id)">
																				<mat-icon>delete</mat-icon>
																			</button>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</mat-card-content>
												</mat-card>
											</ng-template>
										</mat-tab>
									</mat-tab-group>
								</ng-template>
							</mat-tab>

							<mat-tab label="Archived" class="no-overflow">
								<app-archived-statements class="w-100"></app-archived-statements>
							</mat-tab>

						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>